import $ from "jquery";

// Questo modulo deve essere valutato prima di Bootstrap: gli import statici
// vengono eseguiti prima del corpo di globals.ts, anche a DOM già caricato.
window.$ = $;
window.jQuery = $;
